module.exports = __webpack_public_path__ + "static/media/card_icon_9.9ebbf6fd.png";